import { FC } from "react";
import { PleskSiteDetails } from "../components/PleskSiteDetails";
import { useParams } from "react-router-dom";
import { ContentContainer } from "@hostingbv/lib/src/components/content/ContentContainer";
import { PageIconHeader } from "@hostingbv/lib/src/components/PageIconHeader";
import { faShop } from "@fortawesome/free-solid-svg-icons";
import { Breadcrumbs } from "@hostingbv/lib/src/components/content/Breadcrumbs";
import { PageHeader } from "@hostingbv/lib/src/components/content/PageHeader";
import { EntityNotesButton } from "../components/EntityNotesButton";
import { Loading } from "@hostingbv/lib/src/components/Loading";
import { WindhostingSiteDetails } from "../components/WindhostingSiteDetails";
import { useSite } from "@hostingbv/lib/src/api/partner/PartnerHooks";

export const SiteDetails: FC = () => {
  const { site: uuid } = useParams()
  const { data: site, isLoading } = useSite(uuid!)

  return <ContentContainer>
    <PageIconHeader icon={faShop}>
      <Breadcrumbs currentPage={site?.displayName ?? "Site"} crumbs={[
        { label: "Sites", href: "/sites" },
      ]} />
      <PageHeader>
        {site === null ? <span className={"block h-8 w-36 rounded-lg bg-slate-200 animate-pulse"}></span> : site.displayName}
        <EntityNotesButton entity={site} />
      </PageHeader>
    </PageIconHeader>

    <Loading loading={isLoading}>
      {site && <>
        {['shared_hosting_subscription', 'cluster_hosting'].includes(site.siteType) && <PleskSiteDetails site={site} />}
        {site.siteType === 'windhosting_site' && <WindhostingSiteDetails site={site} />}
      </>}
    </Loading>
  </ContentContainer>
}
